export default "__VITE_ASSET__BEnm7msn__"